const ldRgbLightUpBtns = document.getElementsByClassName(
  "light-logo__selection__btns__img"
);
const ldRgbLightLogoImg = document.getElementById("lightLogoImg");

const ldRgbLightUpBtnSrc = [
	"//www.vertagear.com/cdn/shop/t/78/assets/ld-rgb-light-up-icon-1.svg?v=55344394610618133191680575729",
  "//www.vertagear.com/cdn/shop/t/78/assets/ld-rgb-light-up-icon-2.svg?v=75421207901051139551680575730",
  "//www.vertagear.com/cdn/shop/t/78/assets/ld-rgb-light-up-icon-3.svg?v=116636717394798725771680575731",
  "//www.vertagear.com/cdn/shop/t/78/assets/ld-rgb-light-up-icon-4.svg?v=125137274486766123421680575731",
  "//www.vertagear.com/cdn/shop/t/78/assets/ld-rgb-light-up-icon-5.svg?v=46333226395669712841680575732",
]
const ldRgbLightUpBlueBtnSrc = [
	"//www.vertagear.com/cdn/shop/t/78/assets/ld-rgb-light-up-icon-active-1.svg?v=182887324672742304131680575733",
  "//www.vertagear.com/cdn/shop/t/78/assets/ld-rgb-light-up-icon-active-2.svg?v=48492712510123258321680575733",
  "//www.vertagear.com/cdn/shop/t/78/assets/ld-rgb-light-up-icon-active-3.svg?v=151887550279477444461680575734",
  "//www.vertagear.com/cdn/shop/t/78/assets/ld-rgb-light-up-icon-active-4.svg?v=176083485775527128751680575735",
  "//www.vertagear.com/cdn/shop/t/78/assets/ld-rgb-light-up-icon-active-5.svg?v=92558019364941127061680575735",
]
const ldRgbLightUpMainImgSrc = [
	"//www.vertagear.com/cdn/shop/t/78/assets/ld-rgb-light-up-desk-1.jpeg?v=16782211859085997051669085955",
  "//www.vertagear.com/cdn/shop/t/78/assets/ld-rgb-light-up-desk-2.jpeg?v=15108724892089923281669085956",
  "//www.vertagear.com/cdn/shop/t/78/assets/ld-rgb-light-up-desk-3.jpeg?v=48545896342413010181669085957",
  "//www.vertagear.com/cdn/shop/t/78/assets/ld-rgb-light-up-desk-4.jpeg?v=89823402611106198061669085941",
  "//www.vertagear.com/cdn/shop/t/78/assets/ld-rgb-light-up-desk-5.jpeg?v=31661359781726792251669085943",
]

for (let i = 0; i < ldRgbLightUpBtns.length; i++) {
  const element = ldRgbLightUpBtns[i];
  element.addEventListener("click", () => {
    for (let m = 0; m < ldRgbLightUpBtns.length; m++) {
      const e = ldRgbLightUpBtns[m];
      e.src = ldRgbLightUpBtnSrc[m];
    }
    element.src = ldRgbLightUpBlueBtnSrc[i];
    ldRgbLightLogoImg.src = ldRgbLightUpMainImgSrc[i];
  });
}

// Feature controls
// let ldRgbFeatureTransform = 0;
// let ldRgbFeatureClickTimes = 0;
// const featuresControlRightBtn = document.getElementById(
//   "featuresControlRightBtn"
// );
// const featuresControlLeftBtn = document.getElementById(
//   "featuresControlLeftBtn"
// );
// const featuresMainContainer = document.getElementById("featuresMainContainer");
// featuresControlRightBtn.addEventListener("click", () => {
//   if (ldRgbFeatureClickTimes < 1) {
//     ldRgbFeatureClickTimes++;
//     ldRgbFeatureTransform -= 624;
//     featuresMainContainer.style.transform = `translate(${ldRgbFeatureTransform}px)`;
//   }
// });
// featuresControlLeftBtn.addEventListener("click", () => {
//   if (ldRgbFeatureClickTimes > 0) {
//     ldRgbFeatureClickTimes--;
//     ldRgbFeatureTransform += 624;
//     featuresMainContainer.style.transform = `translate(${ldRgbFeatureTransform}px)`;
//   }
// });

// Scroll to play video
window.addEventListener("load", ldRgbVideoScroll);
window.addEventListener("scroll", ldRgbVideoScroll);

function ldRgbVideoScroll() {
  const windowHeight = window.innerHeight;
  const videoEl = document.getElementById("ldRgbLightUpLogo");

  const videoHeight = videoEl.clientHeight;
  const videoClientRect = videoEl.getBoundingClientRect().top;

  if (
    videoClientRect <= windowHeight - videoHeight * 0.5 &&
    videoClientRect >= 0 - videoHeight * 0.5
  ) {
    videoEl.play();
  } else {
    videoEl.pause();
  }
}

// Faq
const ldRgbQuestions = document.getElementsByClassName("faq__each");
const ldRgbArrowBtns = document.getElementsByClassName("faq__arrow");
const ldRgbAnswers = document.getElementsByClassName("faq__answer");

for (let i = 0; i < ldRgbArrowBtns.length; i++) {
  const questionE = ldRgbQuestions[i];
  const arrowE = ldRgbArrowBtns[i];
  let isDisplay = false;
  questionE.addEventListener("click", () => {
    const answerE = ldRgbAnswers[i];
    if (isDisplay) {
      answerE.style.display = "none";
      isDisplay = false;
      arrowE.style.transform = "rotate(0)";
    } else {
      answerE.style.display = "block";
      isDisplay = true;
      arrowE.style.transform = "rotate(90deg)";
    }
  });
}

// New brand review image
const ldRgbLoopChangeSrc = (eList, imgLink) => {
  for (let i = 0; i < eList.length; i++) {
  	eList[i].srcset = imgLink;
  }
}

const ldRgbBrands = document.getElementsByClassName("index-reviews__swiper-slide");

ldRgbLoopChangeSrc(ldRgbBrands[0].getElementsByTagName("SOURCE"), "//www.vertagear.com/cdn/shop/t/78/assets/brand-review-9to5.webp?v=116684212377410244991680681352");
ldRgbLoopChangeSrc(ldRgbBrands[1].getElementsByTagName("SOURCE"), "//www.vertagear.com/cdn/shop/t/78/assets/brand-review-forbes.webp?v=33757161430718868261680681353");
ldRgbLoopChangeSrc(ldRgbBrands[2].getElementsByTagName("SOURCE"), "//www.vertagear.com/cdn/shop/t/78/assets/brand-review-thegamer.webp?v=72809173739353063991680681355");
ldRgbLoopChangeSrc(ldRgbBrands[4].getElementsByTagName("SOURCE"), "//www.vertagear.com/cdn/shop/t/78/assets/brand-review-t3.webp?v=108910884499932718151680681354");
ldRgbLoopChangeSrc(ldRgbBrands[5].getElementsByTagName("SOURCE"), "//www.vertagear.com/cdn/shop/t/78/assets/brand-review-gamesradar.webp?v=60039286964375854491680681353");